import React, { useState } from "react";
import ssoManagementService from "../../../services/SSOManagementService";
import { SSOProviderDTO } from "@beable/roster-backend-client-v1";
import ProviderForm from "../Providers/ProviderForm";
import FormModal, { ModalMessageSettings, getResultMessage } from "../../Common/FormModal";

interface AddProviderModalProps {
  open: boolean;
  handleClose: any;
  selectedItem?: SSOProviderDTO;
}

export default function AddProviderModal(props: AddProviderModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();

  const submitForm = async (providerDto: SSOProviderDTO, allEnvs: boolean) => {
    setIsLoading(true);
    const result = await ssoManagementService.addNewProvider(
      providerDto,
      allEnvs
    );

    const message = getResultMessage(
      result,
      `Provider added successfully!`,
      `Failed to add this provider!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title="Add new SSO provider"
      description="Adds a new SSO provider to Beable."
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      <ProviderForm
        onSubmit={submitForm}
        handleClose={handleClose}
      />
    </FormModal>
  );
}
